import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";

const Farmacias = ({ listaFarmacia }) => {
  return (
    <Container className="mt-4">
      <Row>
        {listaFarmacia.map((farmacia) => (
          <Col key={farmacia.id} md={4} sm={6} xs={12} className="mb-3">
            <Card className="h-100">
              <div className="d-flex justify-content-center mt-3">
                <Card.Img
                  variant="top"
                  src={farmacia.icon}
                  alt={farmacia.name}
                  style={{ height: "70px", width: "155px", color: "#525252" }}
                />
              </div>
              <Card.Body className="d-flex flex-column justify-content-between">
                <Card.Title
                  className="text-center"
                  style={{ color: "#525252",fontWeight:"Bold" ,fontSize:"14px"}}
                >
                  {farmacia.name}
                </Card.Title>
                <div className="d-grid">
                  <Button
                    style={{ backgroundColor: "rgb(0, 52, 121)" }}
                    href={farmacia.link}
                    target="_blank"
                  >
                    Visitar
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Farmacias;
